import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-black/95 backdrop-blur-sm' : 'bg-black/85'
      }`}
    >
      <div className="px-8 lg:px-20">
        <div className="flex items-center justify-between h-20">
          {/* Logo - REMOVED */}

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-12">
            {['HOME', 'ABOUT', 'MUSIC', 'VIDEOS', 'MERCH', 'CONTACT'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="text-white text-sm font-medium tracking-wider hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-cyan-400 hover:to-red-500 transition-all duration-300 relative group whitespace-nowrap"
              >
                {item}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-cyan-400 to-red-500 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
          </div>

          {/* Social Icons & CTA */}
          <div className="hidden lg:flex items-center space-x-6">
            <div className="flex items-center space-x-4">
              <a href="https://open.spotify.com/artist/19027wmWbWJxkzgCA2iV7h?si=qwFGATH3QGCKDBKa5fm1ug" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors duration-300">
                <i className="ri-spotify-fill text-2xl"></i>
              </a>
              <a href="https://music.apple.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors duration-300">
                <i className="ri-apple-fill text-2xl"></i>
              </a>
              <a href="https://youtube.com/@tharealest1088?si=KwyBsKjT64Cf5U-j" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-500 transition-colors duration-300">
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
            </div>
            <a href="https://music.youtube.com/channel/UC0WuiNhaDoBn0-G2_9VOvqw?si=-C1HuNkTLZoMqgRH" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 border-2 border-transparent bg-[#E31E24] text-white text-sm font-semibold rounded-full hover:shadow-lg hover:shadow-[#E31E24]/50 transition-all duration-300 whitespace-nowrap">
              LISTEN NOW
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden text-white text-2xl"
          >
            <i className={mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-6 space-y-4 border-t border-white/10">
            {['HOME', 'ABOUT', 'MUSIC', 'VIDEOS', 'MERCH', 'CONTACT'].map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item.toLowerCase())}
                className="block w-full text-left text-white text-sm font-medium tracking-wider hover:text-cyan-400 transition-colors duration-300 py-2"
              >
                {item}
              </button>
            ))}
            <div className="flex items-center space-x-4 pt-4">
              <a href="https://open.spotify.com/artist/19027wmWbWJxkzgCA2iV7h?si=qwFGATH3QGCKDBKa5fm1ug" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors duration-300">
                <i className="ri-spotify-fill text-2xl"></i>
              </a>
              <a href="https://music.apple.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-cyan-400 transition-colors duration-300">
                <i className="ri-apple-fill text-2xl"></i>
              </a>
              <a href="https://youtube.com/@tharealest1088?si=KwyBsKjT64Cf5U-j" target="_blank" rel="noopener noreferrer" className="text-white hover:text-red-500 transition-colors duration-300">
                <i className="ri-youtube-fill text-2xl"></i>
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
